// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed3810f9","484":"764cb528","551":"a4d28333"}[chunkId] + ".chunk.js";
};